function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/defineProperty.js
 ** module id = 76
 ** module chunks = 0
 **/